import './jquery.validate_en';
import './my_register';
